import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import NewsCard from "@/components/base/NewsCard";
import { newsArticles } from "@/mocks/news";

const sorted = [...newsArticles].sort((a, b) => b.heat - a.heat);
const featured = sorted[0];
const others = sorted.slice(1, 4);

export default function NewsSection() {
  return (
    <section className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="花絮与幕后"
        title="镜头背后的操作，我们替你问到了"
        description="拍摄花絮、幕后制作故事与口碑解读，均由本社编辑部整理，尽量还原现场真实情况。"
        action={{ to: "/news", label: "全部爆料资讯" }}
      />

      <div className="mt-9 grid grid-cols-1 gap-5 lg:grid-cols-12">
        <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7">
          <Link to={`/news/${featured.id}`} className="block">
            <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
              <img
                src={featured.cover}
                alt={`${featured.title} 配图`}
                title={`${featured.title} 幕后制作故事`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
              />
            </div>
          </Link>
          <div className="flex flex-1 flex-col p-5 md:p-7">
            <div className="flex items-center gap-3 text-xs text-foreground-500">
              <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-primary-700">
                编辑推荐
              </span>
              <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-accent-900">
                {featured.category}
              </span>
              <time>{featured.date}</time>
            </div>
            <Link to={`/news/${featured.id}`}>
              <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                {featured.title}
              </h3>
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
            <Link
              to={`/news/${featured.id}`}
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
            >
              阅读幕后故事
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </article>

        <div className="flex flex-col gap-4 lg:col-span-5">
          {others.map((article) => (
            <NewsCard key={article.id} article={article} layout="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}